// src/services/generateurService.js
import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

//type generateur
export const getTypeGenerateur = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/type_generateur`);
};

export const postTypeGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/type_generateur`, data);
};

export const getMarqueGenerateur  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/marque_generateur`);
};

export const postMarqueGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/marque_generateur`, data);
};

export const getModeleGenerateur  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/modele_generateur`);
};

export const getModeleGenerateurOne  = async (id) => {
  return userRequest.get(`${DOMAIN}/api/generateur/modele_generateur/one`,{
    params: {
      id_marque_generateur: id
    }
  });
};

export const postModeleGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/modele_generateur`, data);
};

export const getRefroidissement  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/refroidissement`);
};

export const getGenerateur = async (user) => {
    return userRequest.get(`${DOMAIN}/api/generateur`);
  };

export const getGenerateurOne= async (id) => {
    return userRequest.get(`${DOMAIN}/api/generateur/one?id_generateur=${id}`);
  };

export const postGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
    });
};

export const putGenerateur = async (data) => {
  return userRequest.put(`${DOMAIN}/api/generateur`, data);
};

//Relier un générateur à un fichier excel
export const putRelierGenerateurFichier = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/generateur/relier_generateur?id_generateur=${id}`, data);
};

//Plein generateur
export const getPleinGenerateur  = async (data) => {
  return userRequest.get(`${DOMAIN}/api/generateur/plein_generateur`,{
    params: data
  });
};

export const getPleinGenerateurV  = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/plein_generateurV`, data);
};

export const getPleinGenerateurLimit  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/plein_generateur_ten`);
};

export const getPleinGenerateurOne  = async (id) => {
  return userRequest.get(`${DOMAIN}/api/generateur/plein_generateur/one`,{
    params: {
      id_plein_generateur: id
    }
  });
};

export const postPleinGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/plein_generateur`, data);
};

export const putPleinGenerateur =  async(data) => {
  return userRequest.put(`${DOMAIN}/api/generateur/plein_generateur`, data)
}

export const deletePleinGenerateur =  async(id) => {
  return userRequest.put(`${DOMAIN}/api/generateur/plein_generateur/sup?id_plein_generateur=${id}`)
}

//Rapport plein generateur
export const getRapportPleinGenerateur = async (date_debut, date_fin) => {
  return userRequest.get(`${DOMAIN}/api/generateur/rapport_generateur_plein`, {
    params: {
      date_debut,
      date_fin
    }
  });
};

//Inspection générateur
export const getInspectGenerateur  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/inspect_generateur`);
};

export const postInspectGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/inspect_generateur`, data);
};

//Sous Inspection générateur
export const getInspectGenerateurById  = async (id) => {
  return userRequest.get(`${DOMAIN}/api/generateur/sous_inspect_generateurById`,{
    params: {
      id_inspection_generateur: id
    }
  });
};

//Validation inspection générateur
export const getInspectionGenerateurValide = async (id) => {
    return userRequest.get(`${DOMAIN}/api/generateur/inspection_validation`, {
      params: {
        id_sub_inspection_generateur : id
      }
    });
}

export const postInspectionGenerateurValide= async (data) => {
    return userRequest.post(`${DOMAIN}/api/generateur/inspection_validation`, data );
}

export const putInspectionGenerateurValide= async (data) => {
    return userRequest.put(`${DOMAIN}/api/generateur/inspection_validation_put`, data );
}

//Reparation générateur
export const getRepGenerateur  = async () => {
  return userRequest.get(`${DOMAIN}/api/generateur/rep_generateur`);
};

export const getRepGenerateurOne  = async (id) => {
  return userRequest.get(`${DOMAIN}/api/generateur/rep_generateurOne`, {
    params: {
      id_reparations_generateur : id
    }
  });
};

export const postRepGenerateur = async (data) => {
  return userRequest.post(`${DOMAIN}/api/generateur/rep_generateur`, data);
};

//Sous reparation generation
export const getRepSousGeneById  = async (id) => {
  return userRequest.get(`${DOMAIN}/api/generateur/sous_rep_genById`, {
    params: {
      id_sub_reparations_generateur : id
    }
  });
};